import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import { handleFeedBackAction } from 'redux/parent/actions';
import httpClient from 'utils/http-client';
import { handleError } from '../../../utils/utils';
import { addStudentCommentFail, addStudentCommentSuccess } from '../actions';
import configActionTypes from '../types';

export function* addStudentComment({ payload }) {
  try {
    const response = yield httpClient.post(`/term-comments`, payload);
    yield put(addStudentCommentSuccess(response.data));
    Notify('Comment updated successfully', { position: 'top-right' });
    yield put(handleFeedBackAction(true)); // Open Feedback modal
  } catch (error) {
    yield put(addStudentCommentFail(error?.message));
    handleError(error);
  }
}

export function* onAddStudentComment() {
  yield takeLatest(configActionTypes.ADD_STUDENT_COMMENT_START, addStudentComment);
}
